import {
    GET_USUARIO_DETALLES, MODIFY_USUARIO_DETALLES, UPDATE_USUARIO_DETALLES, ADD_NEW_USUARIO
} from '../constants/action_types';

const initialState = { usuarioDetalles: {}, isLoading: true, updated: false };

export default function (state = initialState, action) {

    switch (action.type) {

        case GET_USUARIO_DETALLES:

            return { ...state, isLoading: true };

        case GET_USUARIO_DETALLES + "_SUCCESS":

            return {
                usuarioDetalles: { ...action.payload.data },
                updated: false,
                isLoading: false
            };


        case ADD_NEW_USUARIO:

            return {
                usuarioDetalles: {
                    id: -1,
                    codigoUsuario: '',
                    password: '',
                    nombre: '',
                    centroId: action.payload.defaultCenter,
                    activo: true,
                },
                updated: false,
                isLoading: false
            };


        case MODIFY_USUARIO_DETALLES:

            const field = action.payload.field,
                value = action.payload.value;

            return {
                usuarioDetalles: { ...state.usuarioDetalles, [field]: value },
                updated: false,
                isLoading: false
            };


        case UPDATE_USUARIO_DETALLES:

            return {
                usuarioDetalles: action.payload,
                updated: true,
                isLoading: false
            };

        default:

            return state;
    };

};